import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

const logoShine = keyframes`
  0%, 24% {
    background-position: 180% 0;
    opacity: 0;
  }
  30% {
    opacity: 0.9;
  }
  80% {
    background-position: -80% 0;
    opacity: 0.9;
  }
  88%, 100% {
    background-position: -80% 0;
    opacity: 0;
  }
`;

const logoColorReveal = keyframes`
  0%, 24% {
    clip-path: inset(0 100% 0 0);
  }
  80%, 100% {
    clip-path: inset(0 0 0 0);
  }
`;

interface RtaDexLogoProps {
  compact?: boolean;
  showChineseName?: boolean;
  size?: 'small' | 'medium';
  animated?: boolean;
}

export const RtaDexLogo: React.FC<RtaDexLogoProps> = ({ size = 'medium', animated = false }) => {
  const isSmall = size === 'small';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        position: 'relative',
        width: isSmall ? { xs: 116, sm: 142 } : { xs: 184, sm: 220 },
        flexShrink: 0,
        lineHeight: 0,
        isolation: 'isolate',
        ...(animated && {
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            zIndex: 0,
            pointerEvents: 'none',
            backgroundColor: '#123B73',
            WebkitMask: 'url("/brand/rtadex-logo.png") center / 100% 100% no-repeat',
            mask: 'url("/brand/rtadex-logo.png") center / 100% 100% no-repeat',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            zIndex: 2,
            pointerEvents: 'none',
            background: 'linear-gradient(108deg, transparent 36%, rgba(255,255,255,.95) 49%, rgba(103,232,249,.72) 53%, transparent 66%)',
            backgroundSize: '240% 100%',
            WebkitMask: 'url("/brand/rtadex-logo.png") center / 100% 100% no-repeat',
            mask: 'url("/brand/rtadex-logo.png") center / 100% 100% no-repeat',
            animation: `${logoShine} 5.6s cubic-bezier(.4, 0, .2, 1) 1 forwards`,
          },
          '@media (prefers-reduced-motion: reduce)': {
            '&::after': { animation: 'none' },
            '& img': { animation: 'none', clipPath: 'inset(0)' },
          },
        }),
      }}
    >
      <Box
        component="img"
        src="/brand/rtadex-logo.png"
        alt="RtaDex 智旅汇"
        sx={{
          display: 'block',
          position: 'relative',
          zIndex: 1,
          width: '100%',
          height: 'auto',
          ...(animated && {
            clipPath: 'inset(0 100% 0 0)',
            animation: `${logoColorReveal} 5.6s cubic-bezier(.4, 0, .2, 1) 1 forwards`,
          }),
        }}
      />
    </Box>
  );
};

export default RtaDexLogo;
